import { DOCUMENT } from '@angular/common';
import { inject } from '@angular/core';
import {
    ChatProviderInstance,
    ChatTypeName,
} from '@sxm-core/utility-code/angular/configuration-token-chat-provider-instance';

declare global {
    interface Window {
        sierraSXM: {
            openChatModal: () => void;
        };
    }
}

export class ChatProviderSierra implements ChatProviderInstance {
    private readonly document = inject(DOCUMENT);
    name = 'sierra' as ChatTypeName;

    constructor() {
        const styleElement = this.document.createElement('style');
        styleElement.textContent = `div[data-sierra-chat-launcher] { position: absolute; }`;
        this.document.head.appendChild(styleElement);
    }

    openChat() {
        const sierraApi = this.document?.defaultView?.sierraSXM;
        sierraApi?.openChatModal();
    }
}
